var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGbm = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.18272C16 7.59798 15.9466 7.03846 15.8474 6.50043H8.17029V9.58292L12.5917 9.58386C12.4123 10.6095 11.8352 11.4838 10.9509 12.0667V14.0665H13.5828C15.1196 12.6738 16 10.6151 16 8.18272Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.952 12.0666C10.2194 12.5504 9.27598 12.8335 8.1723 12.8335C6.04031 12.8335 4.23169 11.4267 3.58398 9.53053H0.869141V11.593C2.21416 14.2066 4.9786 16 8.1723 16C10.3797 16 12.2341 15.2892 13.5839 14.0655L10.952 12.0666Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3282 8.0005C3.3282 7.46807 3.41882 6.95339 3.58385 6.46953V4.40706H0.869014C0.312882 5.4878 0 6.70772 0 8.0005C0 9.29328 0.313836 10.5132 0.869014 11.5939L3.58385 9.53147C3.41882 9.04761 3.3282 8.53293 3.3282 8.0005Z",
    fill: "#FABB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17228 3.16656C9.37707 3.16656 10.4559 3.57289 11.3078 4.36686L13.6401 2.08489C12.2235 0.793042 10.3768 0 8.17228 0C4.97953 0 2.21413 1.79345 0.86911 4.40703L3.58395 6.4695C4.23166 4.5733 6.04028 3.16656 8.17228 3.16656Z",
    fill: "#E94235"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGbm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gbm.b2720ce8.svg";
export { ForwardRef as ReactComponent };